// Client-side device sniffing helpers.
//
// These mirror the server's `RequestContext::HasContainer` device methods
// (`app/view_models/request_context/has_container.rb`) but are more accurate: only the
// client can resolve iPadOS 13+, which reports a desktop "Macintosh" user agent and is
// disambiguated via `navigator.maxTouchPoints` (see
// https://developer.apple.com/forums/thread/119186).
//
// Prefer UA-Client-Hints (`navigator.userAgentData`) where available, falling back to a
// user-agent token match.

function userAgent() {
    return (navigator.userAgent || '');
}

// True for iPadOS 13+, which masquerades as a Mac desktop. The only client-side tell is a
// touch-capable "Macintosh".
function isIpadOs() {
    return /Macintosh/i.test(userAgent()) && (navigator.maxTouchPoints || 0) > 1;
}

export function isIos() {
    return /iPhone|iPad|iPod/i.test(userAgent()) || isIpadOs();
}

export function isAndroid() {
    return /Android/i.test(userAgent());
}

export function isMobileBrowser() {
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
        if (navigator.userAgentData.mobile) { return true; }
        // userAgentData.mobile is false for tablets (incl. iPadOS) — fall through to the UA check.
    }
    return /Android|iPhone|iPad|iPod|Mobile|Opera Mini|BlackBerry|IEMobile/i.test(userAgent()) || isIos();
}
